







































































import { Accessory } from "@/models/products/accessory";
import { Component } from "vue-property-decorator";
import Collections from "./Collections";
import Search from "@/components/elements/utility/Search.vue";
import DataTable from "@/components/elements/utility/Table.vue";
import QtyPicker from "@/components/elements/utility/QtyPicker.vue";
import AddListToQuoteFooter from "@/components/footer/AddListToQuoteFooter.vue";
import { ProductType } from "@/models/products/product";
import { LineItem, Note } from "@/models/order/order";
import { namespace } from "vuex-class";
import { StoreModule } from "@/store/types";
import { OrderActions } from "@/store/modules/order/types";
import { EventBus } from "@/event-bus";
import { GlobalActions, GlobalGetters } from "@/store/modules/global/types";
import PriceSurchargeModal from "@/components/elements/modal/PriceSurchargeModal.vue";

@Component({
  components: {
    Search,
    DataTable,
    QtyPicker,
    AddListToQuoteFooter,
    PriceSurchargeModal,
  }
})
export default class AccessoryMenu extends Collections {
  @(namespace(StoreModule.Order).Action(OrderActions.AddLineItem))
  addItem!: (value: LineItem) => Promise<void>;
  @(namespace(StoreModule.Global).Action(GlobalActions.AddMultiplier))
  addMultiplier!: (value: number) => Promise<void>;
  @(namespace(StoreModule.Global).Getter(GlobalGetters.GetMultiplier))
  multiplier!: number;

  private search = "";
  protected ProductType = ProductType;
  protected lineItems: LineItem[] = [];
  protected lineItemsMultiplier = 1;
  protected showSurchargeModal = false;
  protected hasUserSeenSurchargeModal = false;
  protected surchargeValueStr: string =
    process.env.VUE_APP_PRICE_SURCHARGE_VALUE_STRING || "0%";
  protected surchargeValueNum = 1;
  protected hasCalculatedGlobalSurcharge = false;

  created() {
    this.lineItemsMultiplier = this.multiplier;
    this.calculateSurchargeValueNum();
  }

  beforeDestroy(): void {
    this.showSurchargeModal = false;
    this.hasUserSeenSurchargeModal = false;
  }

  protected closeModal(): void {
    this.showSurchargeModal = false;
    this.hasUserSeenSurchargeModal = true;
  }

  /**
   * Galvanized Plate Base Top Covers need to be handled specially, and
   * Marella Add-Ons are not to be displayed here.
   */
  get accessories(): Accessory[] {
    // filter out marella add-ons
    const marellaAddOnModels = ["MLA-FC", "MLA-SW", "MLA-FW", "MLA-HC"];
    let accessories = ((this.collections as any) as Accessory[]).filter(
      item => !marellaAddOnModels.includes(item.model)
    );
    // apply global price multiplier to all accessories
    if (accessories.length > 0 && !this.hasCalculatedGlobalSurcharge) {
      accessories.forEach(item => {
        if (item.price_id) {
          item.price_id.msrp = this.calculateItemPriceWithSurcharge(
            item.price_id.msrp
          );
        }
      });
      this.hasCalculatedGlobalSurcharge = true;
    }
    // handle G Plate TCs
    const topCoverModels: Accessory[] = [];
    accessories = accessories.filter(item => {
      if (item.model.substring(item.model.length - 3) === "-TC") {
        topCoverModels.push(item);
        return false;
      }
      return true;
    });
    topCoverModels.forEach((topCover, index) => {
      topCover.finishes!.forEach((finishObj, idx) => {
        const topCoverAccessory = { ...topCoverModels[index] };
        topCoverAccessory.price_id = { ...topCoverModels[index].price_id! };
        topCoverAccessory.model = `${
          topCover.model
        }-${((finishObj.handle as any) as string).toUpperCase()}`;
        topCoverAccessory.display_name = `${topCoverAccessory.display_name} - ${finishObj.display_name} Finish`;
        const priceFinishObj = topCoverAccessory.price_id!.finishes!.find(
          finishPrice => finishPrice.handle === finishObj.handle
        );
        topCoverAccessory.price_id!.msrp = this.calculateItemPriceWithSurcharge(
          priceFinishObj!.upcharge
        );
        topCoverAccessory.price_id!.model = topCoverAccessory.model;
        accessories.push(topCoverAccessory);
      });
    });
    if (!this.showSurchargeModal && !this.hasUserSeenSurchargeModal) {
      setTimeout(() => {
        this.showSurchargeModal = true;
      }, 1000);
    }
    return accessories;
  }

  get itemPriceTotal(): number {
    let price = 0;
    for (const item of this.lineItems) {
      price = price + item.unit_price * item.qty * item.multiplier;
    }
    return price;
  }

  get msrpTotal(): number {
    let price = 0;
    for (const item of this.lineItems) {
      price = price + item.unit_price * item.qty;
    }
    return price;
  }

  protected calculateSurchargeValueNum(): void {
    const surchargeStr = this.surchargeValueStr.replace("%", "");
    const surchargeNum = parseFloat(surchargeStr);
    if (!isNaN(surchargeNum)) {
      this.surchargeValueNum = 1 + surchargeNum / 100;
    }
  }

  protected calculateItemPriceWithSurcharge(basePrice: number): number {
    return parseFloat((basePrice * this.surchargeValueNum).toFixed(2));
  }

  protected addToQuote() {
    let itemsQty = 0;
    for (const item of this.lineItems) {
      this.addItem(item);
      itemsQty += item.qty;
    }
    this.addMultiplier(this.lineItemsMultiplier);
    EventBus.$emit("addToCartModal", {
      qty: itemsQty,
      accessoryList: this.lineItems
    });
  }

  protected setQty(qty: number, model: string): void {
    this.triggerUpdate(model, { qty });
  }

  protected setMultiplier(model: string, multiplier: number): void {
    this.lineItemsMultiplier = multiplier;
    this.triggerUpdate(model, { multiplier });
  }

  protected triggerUpdate(
    model: string,
    options: { qty?: number; multiplier?: number }
  ): void {
    if (options.qty === 0) {
      this.removeLineItem(model);
    } else {
      this.updateLineItem(model, options);
    }
  }

  protected removeLineItem(model: string): void {
    this.lineItems = this.lineItems.filter(item => item.model !== model);
  }

  protected updateLineItem(
    model: string,
    options: { qty?: number; multiplier?: number }
  ): void {
    const index = this.lineItems.findIndex(item => item.model === model);
    if (index > -1) {
      const obj = { ...this.lineItems[index] };
      obj.qty = options.qty ? options.qty : obj.qty;
      obj.multiplier = this.lineItemsMultiplier;
      this.lineItems.splice(index, 1, obj);
    } else if (options.qty) {
      this.addNewLineItem(model, options);
    }
  }

  protected addNewLineItem(
    model: string,
    options: { qty?: number; multiplier?: number }
  ) {
    const item = this.accessories.find(item => item.model === model);
    const itemObj = {
      product_type: ProductType.Accessory,
      multiplier: this.lineItemsMultiplier,
      sku: "",
      model: model,
      product_line: "",
      qty: options.qty!,
      unit_price: item!.price_id ? item!.price_id.msrp : 0,
      display_name: item!.display_name,
      notes: "",
      item_details: { notes: [{ field: "model", content: "" }] as Note[] }
    };
    this.lineItems.push(itemObj);
  }

  // Triggered from child component, <Search />
  protected submitSearch(searchTerm: string): void {
    this.search = searchTerm;
  }

  get filteredAccessories() {
    if (this.search != "") {
      const skuFilter = (this.accessories as any[]).filter(item => {
        return (
          item.model.toLowerCase().indexOf(this.search.toLowerCase()) !== -1
        );
      });
      const descFilter = this.accessories.filter(item => {
        return (
          item.display_name.toLowerCase().indexOf(this.search.toLowerCase()) !==
          -1
        );
      });
      return skuFilter.concat(descFilter);
    } else {
      return this.accessories;
    }
  }
}
